'use strict';

var GridToolbarSystemStatusHistoryDirective = function GridToolbarSystemStatusHistoryDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-status-history.html'),
    controller: 'GridToolbarSystemStatusHistoryController'
  };
};
GridToolbarSystemStatusHistoryDirective.$inject = [];
module.exports = GridToolbarSystemStatusHistoryDirective;